<template>
    <div>
        <div class="w-full bg-white shadow-lg lg:rounded-lg lg:border lg:border-gray-300 normal-case">
            <div v-if="notifications.length > 0" class="max-h-screen-1/2 lg:max-h-120 overflow-y-scroll overflow-x-hidden">
                <a
                    v-for="(notification, index) in notifications"
                    :key="index"
                    :href="notification.data.action_url"
                    class="mt-1 mb-1 px-4 py-2 flex justify-between space-x-3 hover:bg-green-100 cursor-pointer"
                    @click="readNotification(notification.id)"
                >
                    <div class="flex-none w-16 h-16 rounded-full overflow-hidden border-2 border-gray-200">
                        <user-avatar
                            :avatar-url="notification.data.actor.avatar_url"
                            :username="notification.data.actor.name"
                        ></user-avatar>
                    </div>
                    <div class="flex-auto grid content-around h-16 max-h-full overflow-hidden">
                        <p class="break-words text-gray-600 line-clamp-2">
                            <span class="text-black font-semibold leading-5 text-sm">{{ notification.data.actor.name }}</span>
                            {{ notification.data.massage }}
                        </p>
                        <p class="text-gray-500 text-xs">{{ notification.created_at }}</p>
                    </div>
                </a>
            </div>
            <div v-else class="px-2 py-4 flex items-center justify-center">
                <p class="text-gray-700 text-center">No unreads notification.</p>
            </div>
            <hr />
            <div class="px-2 py-4 text-center">
                <a
                    href="/all-notifications"
                    class="font-semibold text-teal-400  text-center cursor-pointer hover:underline hover:text-teal-700"
                    >See all Notifications</a
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        notifications: {
            type: Array,
            required: true
        }
    },

    methods: {
        readNotification(id) {
            this.$emit('notification-read', id);
        }
    }
};
</script>
